/** Registers the native MKTG 3900 dashboard lesson component once, app-wide. */
const WIDGET_SRC = '/widgets/mktg-3900-dashboard-lesson.js';

export function registerMktgDashboardLesson(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.customElements?.get('mktg-dashboard-lesson')) return;
  if (document.querySelector('script[data-mktg-dashboard-lesson]')) return;
  const script = document.createElement('script');
  script.dataset.mktgDashboardLesson = 'true';
  script.src = WIDGET_SRC;
  script.async = true;
  document.head.appendChild(script);
}

registerMktgDashboardLesson();
